var _path, _path2, _path3, _path4, _circle, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 180,
    viewBox: "0 0 198 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1728 96.7726C16.1728 52.241 52.4269 16.1288 97.1638 16.1288C141.901 16.1288 178.155 52.241 178.155 96.7726C178.155 125.444 163.133 150.628 140.462 164.938C137.224 166.982 136.259 171.258 138.315 174.488C140.368 177.714 144.653 178.667 147.886 176.626C174.402 159.889 192.033 130.385 192.033 96.7726C192.033 44.5873 149.552 2.29508 97.1638 2.29508C44.776 2.29508 2.29508 44.5873 2.29508 96.7726C2.29508 130.385 19.9255 159.889 46.4418 176.626C49.675 178.667 53.9595 177.714 56.0128 174.488C58.0689 171.258 57.1033 166.982 53.8659 164.938C31.1946 150.628 16.1728 125.444 16.1728 96.7726Z",
    fill: "#F88379",
    stroke: "#F88379",
    strokeWidth: 3.40984,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1605 97.0549C16.1605 52.3782 52.3782 16.1605 97.0549 16.1605C100.884 16.1605 103.988 13.0566 103.988 9.2278C103.988 5.39897 100.884 2.29508 97.0549 2.29508C44.7205 2.29508 2.29508 44.7205 2.29508 97.0549C2.29508 100.884 5.39897 103.988 9.2278 103.988C13.0566 103.988 16.1605 100.884 16.1605 97.0549Z",
    fill: "#F3CB84",
    stroke: "#F3CB84",
    strokeWidth: 3.40984,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2731 2.29508C93.4491 2.29508 90.3404 5.38698 90.3404 9.21194C90.3404 13.0369 93.4491 16.1288 97.2731 16.1288C141.955 16.1288 178.167 52.2391 178.167 96.7726C178.167 125.444 163.163 150.629 140.519 164.939C137.284 166.983 136.321 171.258 138.374 174.487C140.425 177.713 144.706 178.667 147.938 176.626C174.424 159.888 192.033 130.384 192.033 96.7726C192.033 44.5892 149.603 2.29508 97.2731 2.29508Z",
    fill: "#80B4E6",
    stroke: "#80B4E6",
    strokeWidth: 3.40984,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M192.035 97.2255C192.035 93.4122 188.927 90.3385 185.116 90.3385C181.305 90.3385 178.198 93.4122 178.198 97.2255C178.198 125.727 163.237 150.765 140.655 164.991C137.427 167.025 136.462 171.284 138.514 174.502C140.562 177.713 144.833 178.66 148.055 176.63C174.47 159.988 192.035 130.65 192.035 97.2255Z",
    fill: "#90DEBA",
    stroke: "#90DEBA",
    strokeWidth: 3.40984,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99.5061,
    cy: 95.6366,
    r: 21.1469,
    fill: "#4C5160"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 186.364,
    y: 36.7231,
    width: 10.7658,
    height: 114.89,
    rx: 4.26229,
    transform: "rotate(58.4061 186.364 36.7231)",
    fill: "#4C5160"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 193.524,
    y: 49.3716,
    width: 10.7658,
    height: 113.233,
    rx: 4.26229,
    transform: "rotate(65.4314 193.524 49.3716)",
    fill: "#4C5160",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditClock);
export default __webpack_public_path__ + "static/media/credit-clock.c2b72fcedba8d59bcf704d1f8a2e6314.svg";
export { ForwardRef as ReactComponent };